const React = require('react');
const map = require('mn-utils/map');

const {INTERVALS, INTERVAL_CUSTOM} = require('../../../../constants/intervals');
const TimeIntervalBtn = require('../../../IntervalFilterConstructor/components/TimeIntervalBtn');

const IntervalBtn = require('../IntervalBtn');
const {MerchantSelect} = require("../../../../../../helpers/InputsHelpers");

module.exports = ({data, onChange, disabled}) => {
  return (
    <div className="layoutRow dB@m mh-3 (ph3)>1">
      <div className="wmin160 pb10">
        <MerchantSelect
          propValue="id"
          propName="name"
          items={INTERVALS}
          value={data.interval}
          onChange={(interval) => {
            console.log(interval);
            return (
              onChange && onChange({...data, interval})
            )
          }}
        />
      </div>
      <div>
        <TimeIntervalBtn
          item={{id: INTERVAL_CUSTOM}}
          data={data}
          btnComponent={IntervalBtn}
          onChange={onChange}
          disabled={disabled}
          isCustom
        />
      </div>
    </div>
  );
}
